import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { VacanciesTable } from './Table'

const VacanciesPage = () => {
  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <VacanciesTable />
    </ResponsivePage.Body>
  )
}

export default VacanciesPage
